<template>
  <div :class="`as-goals-scored`">
    <div class="as-goals-scored__head">
      <IconWhistle />
      <span> Đá phạt, Phát bóng và Ném biên </span>
    </div>
    <div class="as-history">
      <div class="as-history-item">
        <div class="as-history-item__head">
          <div
            class="as-head-tab as-uppercase"
            :class="{
              'as-active': activeTab === 'free-kick',
            }"
            @click="setActiveTab('free-kick')"
          >
            đá phạt trực tiếp
          </div>
          <div
            class="as-head-tab as-uppercase"
            :class="{
              'as-active': activeTab === 'kick',
            }"
            @click="setActiveTab('kick')"
          >
            phát bóng từ cầu môn
          </div>
          <div
            class="as-head-tab as-uppercase"
            :class="{
              'as-active': activeTab === 'throw',
            }"
            @click="setActiveTab('throw')"
          >
            ném biên
          </div>
        </div>
        <div class="as-history-item__body">
          <div class="as-competition">
            <table class="as-competition__table">
              <thead>
                <tr>
                  <th>Tổng số quả đá phạt</th>
                  <th class="as-center a">{{ footyStats?.home_name }}</th>
                  <th class="as-center a">{{ footyStats?.away_name }}</th>
                  <th class="as-center a">Trung bình</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in data" :key="index">
                  <td>{{ item.title }}</td>
                  <td :class="`as-center ${item.home._class}`">
                    {{ item.home.value }}{{ item.is_percent ? "%" : "" }}
                  </td>
                  <td :class="`as-center ${item.away._class}`">
                    {{ item.away.value }}{{ item.is_percent ? "%" : "" }}
                  </td>
                  <td :class="`as-center ${item.avg._class}`">
                    {{ item.avg.value }}{{ item.is_percent ? "%" : "" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed } from "vue";
import IconWhistle from "~src/components/icons/foot_stats/IconWhistle.vue";
import type { IMatch } from "~src/interfaces";
import type { IFootyStats, ITeam, IStatsParent } from "~src/interfaces/footystats";
import { getClassForItem } from "~src/helpers/footystats";

interface Props {
  match: IMatch;
  mode?: string;
  footyStats: IFootyStats | null;
  homeTeamInfo: ITeam | null;
  awayTeamInfo: ITeam | null;
}

interface IData {
  title: string;
  home: {
    value: number;
    _class: string;
  };
  away: {
    value: number;
    _class: string;
  };
  avg: {
    value: number;
    _class: string;
  };
  is_percent?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  mode: "as-win",
});
const activeTab = ref("free-kick");
const setActiveTab = (tab: string) => {
  activeTab.value = tab;
};

const data = computed(() => {
  let _data: IData[] = [
    {
      title: "Trung bình trận đấu",
      home: {
        value: getValueWithMode("home", "freekicks_team_avg_overall", false),
        _class: getClassForItem(
          getValueWithMode("home", "freekicks_team_avg_overall", false)
        ),
      },
      away: {
        value: getValueWithMode("away", "freekicks_team_avg_overall", false),
        _class: getClassForItem(
          getValueWithMode("away", "freekicks_team_avg_overall", false)
        ),
      },
      avg: {
        value: calculatorAVG(
          getValueWithMode("home", "freekicks_team_avg_overall", false),
          getValueWithMode("away", "freekicks_team_avg_overall", false)
        ),
        _class: getClassForItem(
          calculatorAVG(
            getValueWithMode("home", "throwins_total_over425_overall", false),
            getValueWithMode("away", "throwins_total_over425_overall", false)
          )
        ),
      },
      is_percent: false,
    },
    {
      title: "Trên 20.5",
      home: {
        value: getValueWithMode("home", "freekicks_total_over205_overall", false),
        _class: getClassForItem(
          getValueWithMode("home", "freekicks_total_over205_overall", false)
        ),
      },
      away: {
        value: getValueWithMode("away", "freekicks_total_over205_overall", false),
        _class: getClassForItem(
          getValueWithMode("away", "freekicks_total_over205_overall", false)
        ),
      },
      avg: {
        value: calculatorAVG(
          getValueWithMode("home", "freekicks_total_over205_overall", false),
          getValueWithMode("away", "freekicks_total_over205_overall", false)
        ),
        _class: getClassForItem(
          calculatorAVG(
            getValueWithMode("home", "freekicks_total_over205_overall", false),
            getValueWithMode("away", "freekicks_total_over205_overall", false)
          )
        ),
      },
      is_percent: true,
    },
    {
      title: "Trên 21.5",
      home: {
        value: getValueWithMode("home", "freekicks_total_over215_overall", false),
        _class: getClassForItem(
          getValueWithMode("home", "freekicks_total_over215_overall", false)
        ),
      },
      away: {
        value: getValueWithMode("away", "freekicks_total_over215_overall", false),
        _class: getClassForItem(
          getValueWithMode("away", "freekicks_total_over215_overall", false)
        ),
      },
      avg: {
        value: calculatorAVG(
          getValueWithMode("home", "freekicks_total_over215_overall", false),
          getValueWithMode("away", "freekicks_total_over215_overall", false)
        ),
        _class: getClassForItem(
          calculatorAVG(
            getValueWithMode("home", "freekicks_total_over215_overall", false),
            getValueWithMode("away", "freekicks_total_over215_overall", false)
          )
        ),
      },
      is_percent: true,
    },
    {
      title: "Trên 22.5",
      home: {
        value: getValueWithMode("home", "freekicks_total_over225_overall", false),
        _class: getClassForItem(
          getValueWithMode("home", "freekicks_total_over225_overall", false)
        ),
      },
      away: {
        value: getValueWithMode("away", "freekicks_total_over225_overall", false),
        _class: getClassForItem(
          getValueWithMode("away", "freekicks_total_over225_overall", false)
        ),
      },
      avg: {
        value: calculatorAVG(
          getValueWithMode("home", "freekicks_total_over225_overall", false),
          getValueWithMode("away", "freekicks_total_over225_overall", false)
        ),
        _class: getClassForItem(
          calculatorAVG(
            getValueWithMode("home", "freekicks_total_over225_overall", false),
            getValueWithMode("away", "freekicks_total_over225_overall", false)
          )
        ),
      },
      is_percent: true,
    },
    {
      title: "Trên 23.5",
      home: {
        value: getValueWithMode("home", "freekicks_total_over235_overall", false),
        _class: getClassForItem(
          getValueWithMode("home", "freekicks_total_over235_overall", false)
        ),
      },
      away: {
        value: getValueWithMode("away", "freekicks_total_over235_overall", false),
        _class: getClassForItem(
          getValueWithMode("away", "freekicks_total_over235_overall", false)
        ),
      },
      avg: {
        value: calculatorAVG(
          getValueWithMode("home", "freekicks_total_over235_overall", false),
          getValueWithMode("away", "freekicks_total_over235_overall", false)
        ),
        _class: getClassForItem(
          calculatorAVG(
            getValueWithMode("home", "freekicks_total_over235_overall", false),
            getValueWithMode("away", "freekicks_total_over235_overall", false)
          )
        ),
      },
      is_percent: true,
    },
    {
      title: "Trên 24.5",
      home: {
        value: getValueWithMode("home", "freekicks_total_over245_overall", false),
        _class: getClassForItem(
          getValueWithMode("home", "freekicks_total_over245_overall", false)
        ),
      },
      away: {
        value: getValueWithMode("away", "freekicks_total_over245_overall", false),
        _class: getClassForItem(
          getValueWithMode("away", "freekicks_total_over245_overall", false)
        ),
      },
      avg: {
        value: calculatorAVG(
          getValueWithMode("home", "freekicks_total_over245_overall", false),
          getValueWithMode("away", "freekicks_total_over245_overall", false)
        ),
        _class: getClassForItem(
          calculatorAVG(
            getValueWithMode("home", "freekicks_total_over245_overall", false),
            getValueWithMode("away", "freekicks_total_over245_overall", false)
          )
        ),
      },
      is_percent: true,
    },
    {
      title: "Trên 25.5",
      home: {
        value: getValueWithMode("home", "freekicks_total_over255_overall", false),
        _class: getClassForItem(
          getValueWithMode("home", "freekicks_total_over255_overall", false)
        ),
      },
      away: {
        value: getValueWithMode("away", "freekicks_total_over255_overall", false),
        _class: getClassForItem(
          getValueWithMode("away", "freekicks_total_over255_overall", false)
        ),
      },
      avg: {
        value: calculatorAVG(
          getValueWithMode("home", "freekicks_total_over255_overall", false),
          getValueWithMode("away", "freekicks_total_over255_overall", false)
        ),
        _class: getClassForItem(
          calculatorAVG(
            getValueWithMode("home", "freekicks_total_over255_overall", false),
            getValueWithMode("away", "freekicks_total_over255_overall", false)
          )
        ),
      },
      is_percent: true,
    },
  ];

  if (activeTab.value === "kick") {
    _data = [
      {
        title: "Total Goal Kicks AVG",
        home: {
          value: getValueWithMode("home", "goal_kicks_total_avg_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "goal_kicks_total_avg_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "goal_kicks_total_avg_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "goal_kicks_total_avg_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "goal_kicks_total_avg_overall", false),
            getValueWithMode("away", "goal_kicks_total_avg_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "goal_kicks_total_avg_overall", false),
              getValueWithMode("away", "goal_kicks_total_avg_overall", false)
            )
          ),
        },
        is_percent: false,
      },
      {
        title: "GK Total 8.5+",
        home: {
          value: getValueWithMode("home", "goal_kicks_total_over85_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "goal_kicks_total_over85_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "goal_kicks_total_over85_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "goal_kicks_total_over85_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "goal_kicks_total_over85_overall", false),
            getValueWithMode("away", "goal_kicks_total_over85_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "goal_kicks_total_over85_overall", false),
              getValueWithMode("away", "goal_kicks_total_over85_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "GK Total 9.5+",
        home: {
          value: getValueWithMode("home", "goal_kicks_total_over95_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "goal_kicks_total_over95_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "goal_kicks_total_over95_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "goal_kicks_total_over95_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "goal_kicks_total_over95_overall", false),
            getValueWithMode("away", "goal_kicks_total_over95_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "goal_kicks_total_over95_overall", false),
              getValueWithMode("away", "goal_kicks_total_over95_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "GK Total 10.5+",
        home: {
          value: getValueWithMode("home", "goal_kicks_total_over105_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "goal_kicks_total_over105_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "goal_kicks_total_over105_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "goal_kicks_total_over105_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "goal_kicks_total_over105_overall", false),
            getValueWithMode("away", "goal_kicks_total_over105_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "goal_kicks_total_over105_overall", false),
              getValueWithMode("away", "goal_kicks_total_over105_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "GK Total 115+",
        home: {
          value: getValueWithMode("home", "goal_kicks_total_over115_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "goal_kicks_total_over115_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "goal_kicks_total_over115_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "goal_kicks_total_over115_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "goal_kicks_total_over115_overall", false),
            getValueWithMode("away", "goal_kicks_total_over115_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "goal_kicks_total_over115_overall", false),
              getValueWithMode("away", "goal_kicks_total_over115_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "GK Total 125+",
        home: {
          value: getValueWithMode("home", "goal_kicks_total_over125_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "goal_kicks_total_over125_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "goal_kicks_total_over125_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "goal_kicks_total_over125_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "goal_kicks_total_over125_overall", false),
            getValueWithMode("away", "goal_kicks_total_over125_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "goal_kicks_total_over125_overall", false),
              getValueWithMode("away", "goal_kicks_total_over125_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "GK Total 135+",
        home: {
          value: getValueWithMode("home", "goal_kicks_total_over135_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "goal_kicks_total_over135_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "goal_kicks_total_over135_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "goal_kicks_total_over135_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "goal_kicks_total_over135_overall", false),
            getValueWithMode("away", "goal_kicks_total_over135_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "goal_kicks_total_over135_overall", false),
              getValueWithMode("away", "goal_kicks_total_over135_overall", false)
            )
          ),
        },
        is_percent: true,
      },
    ];
  }
  if (activeTab.value === "throw") {
    _data = [
      {
        title: "Total Throw-ins AVG",
        home: {
          value: getValueWithMode("home", "throwins_team_avg_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_team_avg_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_team_avg_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_team_avg_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_team_avg_overall", false),
            getValueWithMode("away", "throwins_team_avg_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_team_avg_overall", false),
              getValueWithMode("away", "throwins_team_avg_overall", false)
            )
          ),
        },
        is_percent: false,
      },
      {
        title: "Throw-ins Total 37.5+",
        home: {
          value: getValueWithMode("home", "throwins_total_over375_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_total_over375_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_total_over375_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_total_over375_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_total_over375_overall", false),
            getValueWithMode("away", "throwins_total_over375_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_total_over375_overall", false),
              getValueWithMode("away", "throwins_total_over375_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "Throw-ins Total 38.5+",
        home: {
          value: getValueWithMode("home", "throwins_total_over385_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_total_over385_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_total_over385_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_total_over385_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_total_over385_overall", false),
            getValueWithMode("away", "throwins_total_over385_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_total_over385_overall", false),
              getValueWithMode("away", "throwins_total_over385_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "Throw-ins Total 39.5+",
        home: {
          value: getValueWithMode("home", "throwins_total_over395_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_total_over395_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_total_over395_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_total_over395_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_total_over395_overall", false),
            getValueWithMode("away", "throwins_total_over395_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_total_over395_overall", false),
              getValueWithMode("away", "throwins_total_over395_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "Throw-ins Total 40.5+",
        home: {
          value: getValueWithMode("home", "throwins_total_over405_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_total_over405_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_total_over405_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_total_over405_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_total_over405_overall", false),
            getValueWithMode("away", "throwins_total_over405_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_total_over405_overall", false),
              getValueWithMode("away", "throwins_total_over405_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "Throw-ins Total 41.5+",
        home: {
          value: getValueWithMode("home", "throwins_total_over415_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_total_over415_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_total_over415_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_total_over415_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_total_over415_overall", false),
            getValueWithMode("away", "throwins_total_over415_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_total_over415_overall", false),
              getValueWithMode("away", "throwins_total_over415_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "Throw-ins Total 42.5+",
        home: {
          value: getValueWithMode("home", "throwins_total_over425_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_total_over425_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_total_over425_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_total_over425_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_total_over425_overall", false),
            getValueWithMode("away", "throwins_total_over425_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_total_over425_overall", false),
              getValueWithMode("away", "throwins_total_over425_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "Throw-ins Total 43.5+",
        home: {
          value: getValueWithMode("home", "throwins_total_over435_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_total_over435_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_total_over435_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_total_over435_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_total_over435_overall", false),
            getValueWithMode("away", "throwins_total_over435_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_total_over435_overall", false),
              getValueWithMode("away", "throwins_total_over435_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "Throw-ins Total 44.5+",
        home: {
          value: getValueWithMode("home", "throwins_total_over445_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_total_over445_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_total_over445_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_total_over445_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_total_over445_overall", false),
            getValueWithMode("away", "throwins_total_over445_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_total_over445_overall", false),
              getValueWithMode("away", "throwins_total_over445_overall", false)
            )
          ),
        },
        is_percent: true,
      },
    ];
  }
  console.log(_data)
  return _data;
});

const homeTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
});

const awayTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
});

const getValueWithMode = (team = "home", mode = "btts", is_stats = true) => {
  const __data: IStatsParent = team === "home" ? homeTeamLastX.value : awayTeamLastX.value;

  if (!__data || !__data.stats) {
    return 0;
  }

  const targetStats = is_stats ? __data?.stats : __data?.stats?.additional_info;

  if (targetStats && targetStats.hasOwnProperty(mode)) {
    return targetStats[mode] as number;
  }

  return 0;
};

const calculatorAVG = (home: number, away: number) => {
  const _avg = (home + away) / 2;

  return Math.round(_avg);
};
</script>
<script lang="ts">
export default {};
</script>
